import { Response } from './response.model';

export class UserSession extends Response {
  secretKey:string="";
  token:string="";
  login:string="";
  razaoSocial:string="";
  cnpjEmpresa :string=""; 
  controlAccess:controlAccess;
  logado:boolean = false;
  TokenCiclo:string="";
  ApiAccessKey:string="";
  currentEmpresa:dCurrentEmpresa;
  grupo:string;
  grupo_id:string;
  tipo_empresa:string;
  uuid_empresa:string;
  idPlan:string = "";
  master:boolean = false;
  SocketURL:string;
  uuidUsuario:string;
  nomeUsuario:string;
  tokenSiga:string="";
}

export class controlAccess{
  ipOrigin:string;
  origin:string;
  nivelAccess:nivelAccess;
}

export class nivelAccess{
  group:dGroup
}

export class dGroup{
  name:string;
  formsAccess:any[];
}

export class dCurrentEmpresa{
  tipo:string="";
  cnpj:string="";
  secretKey:string="";
  razaoSocial:string="";
  uuid:string="";
  idPlan:string="";
}


